<template>
  <div>
    <SampleSearchForm
      :listForm="searchList"
      @handlerSearch="onSearch"
    />
    <div class="cml-button-group">
      <el-button
        size="mini"
        type="primary"
        :disabled="selectData.length < 1"
        v-hasPermission="'warehouse-sample-manage/sample-approval-batch'"
        @click="batchVerify"
        >批量审批</el-button
      >
      <el-button
        size="mini"
        type="primary"
        :disabled="selectData.length < 1"
        @click="transferBtn(selectData)"
        v-hasPermission="'warehouse-sample-manage/sample-approval-transfer'"
        >批量转办</el-button
      >
    </div>
    <CommonTable
      ref="CommonTable"
      :loading="tableLoading"
      :tableHead="tableHeadTab"
      :tableData="tableDataTab"
      :tableParam="tableParamTab"
      @page-size-change="pageSizeChange"
      @select-change="selectChange"
    >
      <template #idSlot="{ row }">
        <div class="cml-sample-info-capacity">
          <el-image
            v-if="row.mainImage" 
            style="width: 50px; height: 50px; margin-right: 5px;"
            :src="row.mainImage + $ImgQuality30"
            :preview-src-list="[row.mainImage + $ImgPreviewQuality]"
            fit="contain"
          >
            <div slot="placeholder" class="sample-image-slot">
              加载中
            </div>
          </el-image>
          <div>
            <p>产品ID：{{ row.productId }} </p>
            <span>{{ row.productName }} </span>
            <div v-if="row.capacity">容量：{{ row.capacity }}{{row.unit}}</div>
          </div>
        </div>
      </template>

      <!-- 查看详情 -->
      <template #codeSlot="{ row }">
        <span class="detail-text-class" @click="showDetail(row)">{{
          row.code
        }}</span>
      </template>
        
      <template #operationSlot="{ row }">
        <el-button
          type="text"
          @click="examine(row)"
          v-hasPermission="'warehouse-sample-manage/sample-approval-batch'"
          >审批</el-button
        >
        <el-button
          type="text"
          @click="transferBtn([row])"
          v-hasPermission="'warehouse-sample-manage/sample-approval-transfer'"
          >转办</el-button
        >
      </template>
    </CommonTable>
    <!-- 详情弹窗 -->
    <SampleOperationLogDialog ref="sampleOperationLogDialog" :listData="listData" />
    <!-- 转办 -->
    <el-dialog
      top="20%"
      :visible.sync="transferDialogVisible"
      width="500px"
      :close-on-click-modal="false"
    >
      <el-form :model="demandStaff" ref="demandStaffRef">
        <el-form-item
          label="转办人"
          prop="leadApproval"
          :rules="[
            { required: true, message: '请选择转办人', trigger: 'change' } 
          ]"
        >
          <el-select
            v-model="demandStaff.leadApproval"
            clearable
            filterable
            size="mini"
            placeholder="请选择"
          >
            <el-option
              v-for="item in leaderData"
              :key="item.loginName"
              :value="item.loginName"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="transferDialogVisible=false">取消</el-button>
        <el-button type="primary" @click="transferSaveBtn">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import CommonTable from '@/components/CommonTable';
import SampleSearchForm from '@/components/SampleSearchForm';
import SampleOperationLogDialog from '@/components/SampleOperationLogDialog';
export default {
  components: { CommonTable, SampleSearchForm, SampleOperationLogDialog },
  props: {
    addBtn: {
      type: Function,
      default: null,
    },
  },
  data() {
    return {
      demandStaff: {
        leadApproval: '',
        type: 'CHANGE'
      },
      transferDialogVisible: false,
      searchList: {
        list: [
          {
            tag: 'el-input',
            label: '寻样单编号',
            prop: 'code',
            defaultValue: undefined,
            placeholder: '请输入完整寻样单编号',
          },
          {
            tag: 'el-input',
            label: '产品名称',
            prop: 'productName',
            defaultValue: undefined,
            placeholder: '请输入关键字',
          }
        ],
      },
      listForm: { type: 1 },
      tableLoading: false,
      tableParamTab: {
        pageNo: 1,
        pageSize: 20,
        orderBy: '',
      },
      selectData: [],
      tableHeadTab: [
        {
          label: '产品信息',
          prop: 'id',
          slotColumn: true,
          slotName: 'idSlot',
          width: 200,
        },
        {
          label: '寻样单编号',
          prop: 'code',
          width: 140,
          slotColumn: true,
          slotName: 'codeSlot',
        },
        { label: '申请时间', prop: 'createDate', width: 140 },
        { label: '数量', prop: 'num', width: 80 },
        { label: '单位', prop: 'orderUnit', width: 80 },
        { label: '样品类型', prop: 'sampleTypeName', width: 80 },
        { label: '供应商', prop: 'supplierName' },
        { label: '申请人', prop: 'demandStaffName', width: 100 },
        { label: '需求品牌', prop: 'demandBrandName', width: 100 },
        { label: '用途', prop: 'purpose' },
        {
          label: '操作',
          prop: 'operation',
          slotColumn: true,
          slotName: 'operationSlot',
          width: 100,
        },
      ],
      tableDataTab: {},
      listData: {},
      TransferDialog: [],
      leaderData: [],
      transferList: []
    };
  },
  computed: {},
  mounted() {
    this.getList();
    this.$refs.CommonTable.changeHeight();
    this.$http.leadApprovalConfig.userList({}).then(result => {
      this.leaderData = result.data.filter(item => item.name !== this.$store.getters.userSelf.user.name);
    })
  },
  methods: {
    transferSaveBtn () {
      this.$refs.demandStaffRef.validate((valid) => {
        if (valid) {
          this.$http.sample.changeOrderLead({
            ...this.demandStaff,
            ids: this.transferList.map(item => item.id)
          }).then(() => {
            this.$message.success('转办成功');
            this.transferDialogVisible = false;
            this.getList();
          }).catch(err => {
            this.$message.error(err.msg);
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 查询
    onSearch(val) {
      this.tableParamTab.pageNo = 1;
      this.listForm = { ...this.listForm, ...val };
      this.getList();
    },
    // table数据
    getList() {
      const params = {
        ...this.tableParamTab,
        data: this.listForm,
      };
      this.tableLoading = true;
      this.$http.sample
        .getOrderLeadInfo(params)
        .then(result => {
          this.tableDataTab = result.data;
          this.selectData = [];
          this.$refs.CommonTable.clearCheckboxRow();
        })
        .catch(err => {
          this.$message.error(err.msg);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    // 翻页
    pageSizeChange(pageNo, pageSize) {
      this.tableParamTab.pageNo = pageNo;
      this.tableParamTab.pageSize = pageSize;
      this.getList();
    },
    // table选择框
    selectChange(arr) {
      this.selectData = arr;
    },
    // 审批
    examine(row) {
      row.checkStatus = '';
      const sampleData = [{
        supplierName: row.supplierName,
        list: [row]
      }];
      this.addBtn('bill', sampleData);
    },
    // 转办
    transferBtn(rows) {
      this.transferList = rows;
      this.transferDialogVisible = true;
      this.demandStaff = {
        leadApproval: '',
        type: 'CHANGE'
      }
    },
    batchVerify() {
      const sampleData = this.selectData.reduce((prev, cur) => {
        cur.checkStatus = '';
        prev.push({
          supplierName: cur.supplierName,
          list: [cur]
        });
        return prev;
      }, []);
      this.addBtn('bill', sampleData);
    },
    showDetail(row) {
      this.$refs.sampleOperationLogDialog.dialogVisible = true;
      this.listData = {
        supplierName: row.supplierName,
        list: [row],
      };
    }
  },
};
</script>

<style lang="less" scoped>
</style>